export default {
  MAP_API_KEY: process.env.REACT_APP_HERE_MAPS_API_KEY,
};
